import {translateFunction} from "../../../../localization/TranslationService";
import {Document} from "../../models/Document";
import React, {useEffect, useState} from "react";
import {Alert, Backdrop, Button, CircularProgress, Stack} from "@mui/material";
import {TransferList} from "../../../../components/common/TransferList";
import {DocumentFile} from "../../models/DocumentFile";

import {graphQLServices} from "../../../../services/GraphQLServices";

import {SPLIT_DOCUMENT} from "../graphql/mutations/gqlSplitDocument";
import {ISplitDocumentInput} from "../../models/SplitDocumentInput";
import {toast} from "react-toastify";
import {DocumentFileType} from "../../models/DocumentFileType";

const translate = translateFunction("SureBaseDocuments");
interface ISplitDocumentCardProps{
	document?: Document;
	reloadDocument?: () => void;
	onClose?: () => void;
}

export const SplitDocumentCard: React.FC<ISplitDocumentCardProps> = (props) => {
	const [submitLoading, setSubmitLoading] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string>("");
	const [left, setLeft] = useState<DocumentFile[]>([]);
	const [right, setRight] = useState<DocumentFile[]>([]);
	
	useEffect(() => {
		setLeft(props.document?.files?.filter((it) => it.name !== "Body.html" && it.type !== DocumentFileType.DocumentSource && (it.parentGroupId??0) === 0) ?? []);
	}, [props.document?.files]);
	
	async function splitDocument() {
		if (!props.document?.files)
			return;
		const input: ISplitDocumentInput = {
			documentIdentifier: props.document.identifier,
			currentDocumentFiles: props.document.files.filter((it) => left.findIndex((l) => l.name === it.name) > -1 ).map((f)=> f.id) ?? [],
			newDocumentFiles: props.document.files.filter((it) => right.findIndex((l) => l.name === it.name) > -1 ).map((f)=> f.id) ?? [],
		};
		setSubmitLoading(true);
		setErrorMessage("");
		await graphQLServices.documentsClient.mutate({
			mutation: SPLIT_DOCUMENT,
			variables: {input: input}
		})
			.then(() => {
				toast.success(`Document succesfully split.`);
				props.reloadDocument && props.reloadDocument();
				props.onClose && props.onClose();
			})
			.catch((reason) => setErrorMessage(reason.networkError.result.errors[0].extensions.message));
		setSubmitLoading(false);
	}
	
	function handleOnChange(left: DocumentFile[], right: DocumentFile[]) {
		
		setLeft([...new Set(left)]);
		setRight([...new Set(right)]);
	}
	
	return <>
		<Stack spacing={1}>
			<Backdrop open={submitLoading}><CircularProgress/></Backdrop>
			{errorMessage &&
				<Alert severity={"error"}>{JSON.stringify(errorMessage)}</Alert>
			}
			
			<TransferList
				leftHeader={translate("Current")}
				rightHeader={translate("New")}
				left={left}
				right={right}
				getKey={item => item.id.toString()}
				renderItem={item => item.name}
				onChange={handleOnChange}
				key ="split"
			/>
			<Button variant={"contained"} onClick={splitDocument}>{translate("Approve")}</Button>
		</Stack>
	</>;
};
